import { OrderPageReducer } from "./pages/orders-page/redux";
import { TakeOffToEnRoutePageReducer } from "./pages/take-off-to-en-route-page/redux";
import { orderFeatureApi } from "./redux";
import { CreateOrderReducer } from "./pages/upsert-order-page/redux";
import { UpsertMissionReducer } from "./pages/upsert-mission-page/redux";
import { ChecklistPageReducer } from "./pages/checklist-page/redux";

export const OrderFeatureMiddlewares = [
  orderFeatureApi.middleware,
];

export const OrderFeatureReducers = {
  OrderPageReducer,
  CreateOrderReducer,
  UpsertMissionReducer,
  TakeOffToEnRoutePageReducer,
  ChecklistPageReducer,
  [orderFeatureApi.reducerPath]: orderFeatureApi.reducer,
};
